// Legenda dei layer NOWCAST (radar pioggia, grandine…) mostrata SOPRA la timeline
// (richiesta Giuseppe 2026-07-07). Ogni layer nowcast pubblica la propria legenda
// via evento `wsv2:nowcast-legend` { id, spec } (spec=null per rimuoverla). Qui le
// impilo in una barra centrata sopra la timeline; sparisce quando non ce n'è.
//
// spec = { title, unit?, bar?:[{pos,color}], ticks?:[{pos,label}], steps?:[{color,label}] }
//   - bar+ticks → colorbar orizzontale (es. intensità pioggia mm/h)
//   - steps     → pastiglie discrete etichettate (es. probabilità grandine %)

let box = null;
const active = new Map();   // id → spec (ordine d'inserimento = ordine di stampa)

function timelineDock() {
    return document.querySelector('.wsv2-nowcast-timeline');
}

function mountBox() {
    if (!box) return false;
    const dock = timelineDock();
    if (!dock) return false;
    if (box.parentElement !== dock) dock.appendChild(box);
    return true;
}

function esc(s) {
    return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

function renderSpec(spec) {
    const head = `<div class="wsv2-nl__title">${esc(spec.title)}${spec.unit ? ` <small>${esc(spec.unit)}</small>` : ''}</div>`;
    if (spec.steps) {
        const items = spec.steps.map(s =>
            `<span class="wsv2-nl__step"><i style="background:${esc(s.color)}"></i>${esc(s.label)}</span>`).join('');
        return `<div class="wsv2-nl__item">${head}<div class="wsv2-nl__steps">${items}</div></div>`;
    }
    const grad = (spec.bar || []).map(s => `${esc(s.color)} ${(s.pos * 100).toFixed(1)}%`).join(',');
    const ticks = (spec.ticks || []).map(t =>
        `<span style="left:${(t.pos * 100).toFixed(1)}%">${esc(t.label)}</span>`).join('');
    return `<div class="wsv2-nl__item">${head}
        <div class="wsv2-nl__bar" style="background:linear-gradient(to right, ${grad})"></div>
        <div class="wsv2-nl__ticks">${ticks}</div></div>`;
}

function render() {
    if (!box) {
        box = document.createElement('div');
        box.className = 'wsv2-nowcast-legend wsv2-nowcast-legend--inline';
        box.hidden = true;
    }
    if (!mountBox()) { box.hidden = true; return; }
    if (!active.size) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    box.innerHTML = [...active.values()].map(renderSpec).join('');
}

export function setNowcastLegend(id, spec) {
    if (spec) active.set(id, spec); else active.delete(id);
    render();
}

// Costruisce una spec colorbar dalla palette del motore radar (array
// {value, rgba:[r,g,b,(a)]}). Gradiente per frazione di valore + tick leggibili.
export function barSpecFromPalette(title, unit, palette) {
    const stops = (palette || [])
        .map(p => ({ v: Number(p.value), c: p.rgba }))
        .filter(s => Number.isFinite(s.v) && Array.isArray(s.c) && s.v > 0)
        .sort((a, b) => a.v - b.v);
    if (stops.length < 2) return null;
    const vmax = stops[stops.length - 1].v;
    const rgba = c => `rgba(${Math.round(c[0])},${Math.round(c[1])},${Math.round(c[2])},${c[3] != null ? (c[3] > 1 ? c[3] / 255 : c[3]) : 1})`;
    const bar = stops.map(s => ({ pos: s.v / vmax, color: rgba(s.c) }));
    // Tick: ~5 soglie della palette stessa, distribuite per indice.
    const nTick = Math.min(5, stops.length);
    const ticks = [];
    for (let i = 0; i < nTick; i++) {
        const s = stops[Math.round(i * (stops.length - 1) / (nTick - 1))];
        const label = s.v >= 10 ? String(Math.round(s.v)) : String(Math.round(s.v * 10) / 10);
        ticks.push({ pos: s.v / vmax, label });
    }
    return { title, unit, bar, ticks };
}

export function initNowcastLegend() {
    document.addEventListener('wsv2:nowcast-legend', (e) => {
        const { id, spec } = e.detail || {};
        if (id) setNowcastLegend(id, spec || null);
    });
    document.addEventListener('wsv2:timeline-dock-mounted', (e) => {
        if (e.detail?.dock?.classList?.contains('wsv2-nowcast-timeline')) render();
    });
}
